<script setup lang="ts">
import { useI18n } from '@/plugins/i18n'
import { useSearchStore } from '../../store/index'
import FilterDropdown from '../../FilterDropdown.ce.vue';
import iconStatus from '@/assets/img/icon-search-filter-status.svg';
import iconOpenStatus from '@/assets/img/icon-search-filter-status-active.svg';
import iconPublisher from '@/assets/img/icon-search-filter-publisher.svg';
import iconOpenPublisher from '@/assets/img/icon-search-filter-publisher-active.svg';
import iconDataSet from '@/assets/img/icon-search-filter-document-type.svg';
import iconOpenDataSet from '@/assets/img/icon-search-filter-document-type-active.svg';
import iconOpen from '@/assets/img/icon-search-filter-up-open.svg';
import iconClose from '@/assets/img/icon-search-filter-down.svg';
import iconTimeRange from '@/assets/img/icon-search-filter-calendar.svg';
import iconOpenTimeRange from '@/assets/img/icon-search-filter-calendar-active.svg';
import TimeRangeFilter from '../../SearchFilters/Updates/TimeRange/index.ce.vue';
import { STANDARDS_SEARCH_TAB, UPDATES_SEARCH_TAB } from '@/components/Search/constants.ts';
import { getYearDateRange } from '@/utils/dateHelpers.ts';

//store
const searchStore = useSearchStore()

//translations
const i18nInstance: any = useI18n()
const { t } = i18nInstance

const { start, end } = getYearDateRange();
const endDate = end;
const startDate = start;

const onRangeChange = (range: { start: Date | null; end: Date | null }) => {
  searchStore.setItem('updates.dateStart', range.start);
  searchStore.setItem('updates.dateEnd', range.end);
};

</script>

<template>
    <div class="search-bar-filters">
        <div class="search-filter-item multiselect status">
            <FilterDropdown
                className="dropdown"
                :placeholder="t('document') + ' ' + t('status')" 
                name="status" 
                :multiple="false" 
                :field="`${UPDATES_SEARCH_TAB}.what`" 
                :lookupField="`lookUpOptions.${UPDATES_SEARCH_TAB}.what`" 
                :hasClear="true" 
                :iconMain="iconStatus"
                :iconOpenMain="iconOpenStatus"
                :iconOpen="iconOpen"
                :iconClose="iconClose"                
                :showMoreLink="false"
                :closeOnClickOutside="true"
                :closeOnSelect="true"
                />
        </div>
        <div class="search-filter-item multiselect publisher">
            <FilterDropdown 
                className="dropdown"
                :placeholder="t('publisher')" 
                :searchPlaceholder="t('searchPublisherPlaceholder')"
                name="publisher[]" 
                :multiple="true" 
                :field="`${UPDATES_SEARCH_TAB}.publisher`" 
                :lookupField="`lookUpOptions.${STANDARDS_SEARCH_TAB}.publisher`"
                :hasClear="true" 
                :iconMain="iconPublisher"
                :iconOpenMain="iconOpenPublisher"
                :iconOpen="iconOpen"
                :iconClose="iconClose"                
                :searchable="true"
                :showMoreLink="false"
                :closeOnClickOutside="true" />
        </div>
        <div class="search-filter-item multiselect timerange">
            <TimeRangeFilter 
                :iconMain="iconTimeRange"
                :iconOpenMain="iconOpenTimeRange"
                :iconOpen="iconOpen"
                :iconClose="iconClose"
                :hasClearAll="true" 
                :showCount="true" 
                :closeOnClickOutside="true" 
                :startDate="startDate" 
                :endDate="endDate" 
                @change="onRangeChange"  
                :rangeLabel="t('dateRange')" 
                :placeholder="t('timeRange')">
        </TimeRangeFilter>
        </div>
        <div class="search-filter-item multiselect dataset">
            <FilterDropdown
                className="dropdown"
                :placeholder="t('dataset')" 
                name="dataset" 
                :field="`${UPDATES_SEARCH_TAB}.dataset`"
                :lookupField="`lookUpOptions.${STANDARDS_SEARCH_TAB}.dataset`" 
                :hasClear="true" 
                :iconMain="iconDataSet"
                :iconOpenMain="iconOpenDataSet"
                :iconOpen="iconOpen"
                :iconClose="iconClose"                
                :showMoreLink="false"
                :closeOnClickOutside="true"
                :closeOnSelect="true"
                />
        </div> 
        <div class="search-filter-item cta">
            <div class="clear-all">
                <div class="search-bar-clear-filter" @click="searchStore.clearSearchBarFilters(UPDATES_SEARCH_TAB)">{{t('clearAll')}}</div>
            </div>
            <div class="spacer">&nbsp;</div>
            <div class="search">
                <div class="search-bar-btn-search" @click="searchStore.searchUpdates(false)">&nbsp;</div>
            </div>
        </div>
    </div>
</template>
<style lang="scss">
    @use './style.scss';
</style>